import React, { useEffect, useState } from "react";
import { Autocomplete, Card, Grid, TextField } from "@mui/material";
import MDTypography from "../../controls/MDTypography";
import MDBox from "../../controls/MDBox";
import ManualAyuda from "../../controls/ManualAyuda";
import PageLayout from "../../layauots/PageLayout";
import PieChartCustom from "./PieChartCustom";
import BarChartCustom from "./BarChartCustom";
import BarChartCompostCustom from "./BarChartCompostCustom";
import MDSnackbar from "../../controls/MDSnackbar";
import TableChartCustom from "./TableChartCustom";
import setCookie from "../../Utils/setcookie";
import getCookie from "../../Utils/getcookies";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import MDButton from "../../controls/MDButton";
import { Filter, GraphicEq } from "@mui/icons-material";
import { getData } from "../../Utils/Http/api";
import LineChartCustom from "./LineChartCustom";
import BarChartGroupedCustom from "./BarChartGroupedCustom";
import BarChartStackedCustom from "./BarChartStackedCustom";
import PivotTableChart from './PivotTableChart';

const DashGraphs = () => {
  const [successSB, setSuccessSB] = useState(false);
  const [successSBPrev, setSuccessSBPrev] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorSinGraficosSB, setSinGraficosErrorSB] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [dateTime, setDateTime] = useState("");
  const [graficos, setGraficos] = useState([]);
  const [dashGroups, setDashGroups] = useState([]);

  const closeSuccessSB = () => setSuccessSB(false);
  const closeErrorSB = () => setErrorSB(false);
  const closeErrorSinGraficosSB = () => setSinGraficosErrorSB(false);

  // Cargar grupos de dashboard
  const loadDashboardGroups = async () => {
    try {
      const response = await getData("/DashboardGrupoListar");
      if (response?.isSuccess) {
        setDashGroups(response.value || []);
      }
    } catch (error) {
      console.error("Error cargando grupos de dashboard:", error);
    }
  };

  useEffect(() => {
    loadDashboardGroups();
  }, []);

  let selectedGroup = dashGroups[0] || null;

  const filtroGroupCookie = getCookie("FILTRODASHGRUPO");
  if (filtroGroupCookie !== null) {
    try {
      const filtroGrupoObjeto = JSON.parse(filtroGroupCookie);
      selectedGroup = filtroGrupoObjeto;
    } catch (e) {
      console.error("Error parsing cookie:", e);
    }
  }

  const [selectedValueGroup, setSelectedValueGroup] = useState(selectedGroup);

  // const today = dayjs();
  // const thirtyDaysAgo = dayjs().subtract(30, 'day');

  // const firstDayOfMonth = thirtyDaysAgo.startOf('month');
  // const firstDayOfNextMonth = today.add(1, 'month').startOf('month');

  // let selectedDateFromInitialValue = firstDayOfMonth;
  // let selectedDateToInitialValue = firstDayOfNextMonth;

  // const filtroFechaDesdeCookie = getCookie("FILTRODASHFECHADESDE");
  // if (filtroFechaDesdeCookie !== null) {
  //   selectedDateFromInitialValue = dayjs(filtroFechaDesdeCookie);
  // }

  // const [selectedDateFrom, setSelectedDateFrom] = useState(selectedDateFromInitialValue);

  // const filtroFechaHastaCookie = getCookie("FILTRODASHFECHAHASTA");
  // if (filtroFechaHastaCookie !== null) {
  //   selectedDateToInitialValue = dayjs(filtroFechaHastaCookie);
  // }

  // const [selectedDateTo, setSelectedDateTo] = useState(selectedDateToInitialValue);

  const [visibleGraphs, setVisibleGraphs] = useState(graficos.map(() => true));

  const toggleVisibility = (index) => {
    setVisibleGraphs(prev => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  const handleAutocompleteGrupoChange = (event, value) => {
    setSelectedValueGroup(value);
    setCookie("FILTRODASHGRUPO", JSON.stringify(value), 43200); // 30 días
  };

  const handleFilter = () => {
    fetchData();
  };

  const clearPivotLocalStorage = () => {
    // Limpiar todas las entradas del localStorage que comienzan con 'pivot-'
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('pivot-')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  };

  const fetchData = async () => {
    try {
      if (!selectedValueGroup?.idDashboardGrupo) {
        setSinGraficosErrorSB(true);
        return;
      }

      // Limpiar configuraciones de pivot tables antes de cargar nuevos datos
      clearPivotLocalStorage();

      setSuccessSBPrev(true);
      setSinGraficosErrorSB(false);

      const fechaDesde = '1900-01-01';
      const fechaHasta = '2100-12-31';
      const idDashboardGrupo = selectedValueGroup.idDashboardGrupo;

      const response = await getData(`/DashboardListar?idDashboardGrupo=${idDashboardGrupo}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`);

      if (response?.isSuccess) {
        const graficosList = response.value?.graficosList || [];
        setGraficos(graficosList);

        if (graficosList.length === 0 || graficosList.every(g => !g.graficosUnificados || g.graficosUnificados.length === 0)) {
          setSinGraficosErrorSB(true);
          setSuccessSB(false);
          setSuccessSBPrev(false);
          setErrorSB(false);
        } else {
          setSuccessSB(true);
          setSuccessSBPrev(false);
          setErrorSB(false);
        }
      } else {
        setMensajeError(response?.error || "Error al cargar los datos");
        setSuccessSB(false);
        setErrorSB(true);
        setSuccessSBPrev(false);
      }
    } catch (error) {
      console.log("Errores de Proceso:", error.message);
      setSuccessSB(false);
      setErrorSB(true);
      setSuccessSBPrev(false);
      setMensajeError(error.message);
    }
  };

  useEffect(() => {
    if (selectedValueGroup?.idDashboardGrupo) {
      fetchData();
    }
  }, [selectedValueGroup]);

  useEffect(() => {
    setVisibleGraphs(graficos.map(() => true));
  }, [graficos]);

  const renderGraficos2 = () => {
    return graficos.map((grafico, idx) => {
      try {
        if (!grafico?.graficosUnificados || grafico.graficosUnificados.length === 0) {
          return null;
        }

        if (!visibleGraphs[idx]) {
          return (
            <div key={idx}>
              <MDButton
                style={{ marginTop: '2px', width: '600px' }}
                variant="gradient"
                color="success"
                endIcon={<GraphicEq />}
                onClick={() => toggleVisibility(idx)}
              >
                Mostrar gráfico {grafico.graficosUnificados[0].titulo}
              </MDButton>
            </div>
          );
        }

        const cardContent = () => {
          switch (grafico.graficosUnificados[0].idTipoGrafico) {
            case 1:
              return (
                <PieChartCustom
                  data={grafico.graficosUnificados}
                  mostrarfiltro={true}
                  namekey={"label1"}
                  datakey={"valor1"}
                  title={grafico.graficosUnificados[0]?.titulo}
                  observaciones={""}
                />
              );
            case 2:
              return (
                <BarChartCompostCustom
                  data={grafico.graficosUnificados}
                  namekey={"label1"}
                  datakey={"valor1"}
                  datakey2={"valor2"}
                  title={grafico.graficosUnificados[0]?.titulo}
                  mostrarfiltro={true}
                  nameeje={grafico.graficosUnificados[0]?.valor1Nombre}
                  nameeje2={grafico.graficosUnificados[0]?.valor2Nombre}
                  nameejevertical={grafico.graficosUnificados[0]?.valor1Nombre}
                  nameejevertical2={grafico.graficosUnificados[0]?.valor2Nombre}
                  observaciones={""}
                />
              );
            case 3:
              return (
                <BarChartGroupedCustom
                  data={grafico.graficosUnificados}
                  namekey={"label2"}
                  datakey={"valor1"}
                  namekey2={"label2"}
                  title={grafico.graficosUnificados[0]?.titulo}
                  mostrarfiltro={true}
                  nameeje={grafico.graficosUnificados[0]?.label1Nombre}
                  nameeje2={grafico.graficosUnificados[0]?.label2Nombre}
                  nameejevertical={grafico.graficosUnificados[0]?.valor1Nombre}
                  observaciones={""}
                />
              );
            case 4:
              return (
                <TableChartCustom
                  data={grafico.graficosUnificados}
                  title={grafico.graficosUnificados[0]?.titulo}
                  observaciones={""}
                />
              );
            case 5:
              // Filtrar series que no deben graficarse (Titulo, Fecha, etc.)
              const filteredSeries = grafico.graficosUnificados[0]?.series?.filter(
                s => s.dataKey !== 'Titulo' && s.dataKey !== 'Fecha'
              ) || [];
              return (
                <LineChartCustom
                  idx={idx}
                  data={grafico.graficosUnificados[0]?.dataset}
                  namex="Fecha"
                  seriesy={filteredSeries}
                  title={grafico.graficosUnificados[0]?.titulo || grafico.graficosUnificados[0]?.dataset[0]?.Titulo}
                />
              );
            case 6:
              return (
                <BarChartStackedCustom
                  data={grafico.graficosUnificados}
                  title={grafico.graficosUnificados[0]?.titulo}
                  observaciones={""}
                />
              );
            case 7:
              // Transformar datos al formato requerido por PivotTableChart
              // De: [{ label1/Label1: 'X', label2/Label2: 'Y', valor1/Valor1: 100, ... }, ...]
              // A: Array lineal de objetos con todas las propiedades
              const normalizeName = (name) => (name || '').toString().toLowerCase().replace(/\s+/g, '');
              const isDateLabel = (name) => {
                const normalized = normalizeName(name);
                return normalized.includes('fecha') || normalized === 'fechaevento';
              };
              const normalizeValorValue = (value) => {
                if (value === undefined || value === null || value === '') {
                  return value;
                }
                if (typeof value === 'number') {
                  return value;
                }
                const parsed = Number(String(value).replace(',', '.'));
                return Number.isNaN(parsed) ? null : parsed;
              };
              const normalizeLabelValue = (value, name) => {
                if (value === undefined || value === null) {
                  return value;
                }
                if (typeof value === 'string' && isDateLabel(name) && dayjs(value).isValid()) {
                  return dayjs(value).format('YYYY-MM-DD');
                }
                return value;
              };

              const baseItem = grafico.graficosUnificados[0] || {};
              const maxPivotFields = 15;
              const getFieldValue = (source, prefix, index, suffix = '') =>
                source?.[`${prefix}${index}${suffix}`] ?? source?.[`${prefix.charAt(0).toUpperCase()}${prefix.slice(1)}${index}${suffix}`];

              const labelDefinitions = Array.from({ length: maxPivotFields }, (_, index) => {
                const position = index + 1;
                return {
                  value: getFieldValue(baseItem, 'label', position),
                  name: getFieldValue(baseItem, 'label', position, 'Nombre'),
                  position,
                };
              });

              const valueDefinitions = Array.from({ length: maxPivotFields }, (_, index) => {
                const position = index + 1;
                return {
                  name: getFieldValue(baseItem, 'valor', position, 'Nombre'),
                  position,
                };
              });

              const valueFields = valueDefinitions.map(({ name }) => name).filter(Boolean);

              const transformedData = grafico.graficosUnificados.map(item => {
                const transformedItem = {};

                labelDefinitions.forEach(({ name, position }) => {
                  const labelValue = getFieldValue(item, 'label', position);
                  const normalizedLabel = normalizeLabelValue(labelValue, name);

                  if (normalizedLabel !== undefined && name) {
                    transformedItem[name] = normalizedLabel;
                  }
                });

                valueDefinitions.forEach(({ name, position }) => {
                  const value = getFieldValue(item, 'valor', position);

                  if (value !== undefined && name) {
                    transformedItem[name] = normalizeValorValue(value);
                  }
                });
                
                // Incluir cualquier otro campo adicional que pueda venir
                Object.keys(item).forEach(key => {
                  const normalizedKey = key.toLowerCase();
                  const isLabelNameField = /^label\d+nombre$/.test(normalizedKey);
                  const isValueNameField = /^valor\d+nombre$/.test(normalizedKey);
                  if (!normalizedKey.startsWith('label') && !normalizedKey.startsWith('valor') &&
                      normalizedKey !== 'titulo' && normalizedKey !== 'idtipografico' && normalizedKey !== 'id' &&
                      !isLabelNameField && !isValueNameField) {
                    transformedItem[key] = item[key];
                  }
                });

                return transformedItem;
              });

              return (
                <PivotTableChart
                  data={transformedData}
                  title={grafico.graficosUnificados[0]?.titulo ?? grafico.graficosUnificados[0]?.Titulo}
                  observaciones={grafico.graficosUnificados[0]?.observaciones || ""}
                  storageKey={`pivot-${grafico.graficosUnificados[0]?.titulo ?? grafico.graficosUnificados[0]?.Titulo}`}
                  valueFields={valueFields}
                />
              );
            default:
              return null;
          }
        };

        return (
          <Card key={idx} style={{ marginTop: '10px', flex: 1 }}>
            <MDButton
              style={{ marginTop: '2px', width: '600px' }}
              variant="gradient"
              color="info"
              endIcon={<GraphicEq />}
              onClick={() => toggleVisibility(idx)}
            >
              Ocultar gráfico
            </MDButton>
            {cardContent()}
          </Card>
        );
      } catch (error) {
        console.error("Error renderizando gráfico:", error);
        return null;
      }
    });
  };

  return (
    <PageLayout
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <MDBox width="100%" height="100%">
        <Grid width="80%" justifyContent="center" alignItems="center" height="100%">
          <Card
            style={{
              width: "100%",
              marginLeft: "280px",
              marginTop: "80px",
              marginRight: "auto",
            }}
          >
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={2}
              mt={-3}
              p={3}
              mb={1}
              textAlign="center"
              sx={{ position: "relative" }}
            >
              <MDBox sx={{ position: "absolute", top: 8, right: 8 }}>
                <ManualAyuda seccion="Análisis e Informes" />
              </MDBox>
              <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                Dashboard de Gestión de Casos
              </MDTypography>
              <MDTypography display="block" variant="button" color="white" my={1}>
                Información general y análisis de los casos gestionados
              </MDTypography>
            </MDBox>

            {/* <MDBox mb={2} mt={3} ml={2} style={{ display: "flex", gap: "16px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <DatePicker
                  label="Fecha Desde"
                  value={selectedDateFrom}
                  onChange={(date) => {
                    setSelectedDateFrom(date);
                    setCookie("FILTRODASHFECHADESDE", date.format('YYYY-MM-DD'), 43200);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      sx: { width: 200 }
                    }
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <DatePicker
                  label="Fecha Hasta"
                  value={selectedDateTo}
                  onChange={(date) => {
                    setSelectedDateTo(date);
                    setCookie("FILTRODASHFECHAHASTA", date.format('YYYY-MM-DD'), 43200);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      sx: { width: 200 }
                    }
                  }}
                />
              </LocalizationProvider>
            </MDBox> */}

            <MDBox mb={2} mt={3} ml={2} style={{ display: "flex", gap: "16px" }}>
              <Autocomplete
                options={dashGroups}
                getOptionLabel={(option) => option.grupo || "Seleccione Panel"}
                isOptionEqualToValue={(option, value) =>
                  option.idDashboardGrupo === value.idDashboardGrupo
                }
                value={selectedValueGroup || null}
                onChange={handleAutocompleteGrupoChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccione Panel"
                    variant="outlined"
                    style={{ width: `300px` }}
                  />
                )}
              />

              <MDButton
                onClick={() => {
                  handleFilter();
                }}
                variant="gradient"
                color="info"
                endIcon={<Filter />}
              >
                Filtrar
              </MDButton>
            </MDBox>

            <MDBox p={2} id="capture-area">
              {renderGraficos2()}
            </MDBox>
          </Card>
        </Grid>
      </MDBox>

      <MDSnackbar
        color="info"
        icon="processing"
        title="Data Muni"
        content="Cargando paneles..."
        dateTime={dateTime}
        open={successSBPrev}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
      />
      <MDSnackbar
        color="success"
        icon="notifications"
        title="Data Muni"
        content="Paneles Cargados exitosamente"
        dateTime={dateTime}
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
      />
      <MDSnackbar
        color="error"
        icon="warning"
        title="Data Muni"
        content={mensajeError}
        dateTime={dateTime}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
      />
      <MDSnackbar
        color="warning"
        icon="warning"
        title="Data Muni"
        content="No hay gráficos disponibles para las fechas indicadas"
        dateTime={dateTime}
        open={errorSinGraficosSB}
        onClose={closeErrorSinGraficosSB}
        close={closeErrorSinGraficosSB}
      />
    </PageLayout>
  );
};

export default DashGraphs;
